import { HttpInterceptorFn, HttpResponse } from '@angular/common/http';
import { tap } from 'rxjs/operators';

export const stringToDateInterceptor: HttpInterceptorFn = (req, next) => {
  const iso8601 = /^\d{4}-\d\d-\d\dT\d\d:\d\d:\d\d(\.\d+)?(([+-]\d\d:\d\d)|Z)?$/;

  const isIso8601 = (value: any): boolean => {
    if (value === null || value === undefined) {
      return false;
    }
    return iso8601.test(value);
  };

  const convertToDate = (body: any): any => {
    if (body === null || body === undefined) {
      return body;
    }

    if (typeof body !== 'object') {
      return body;
    }

    for (const key of Object.keys(body)) {
      const value = body[key];
      if (isIso8601(value)) {
        body[key] = new Date(value);
      } else if (typeof value === 'object') {
        convertToDate(value);
      }
    }
  };

  return next(req).pipe(
    tap(event => {
      if (event instanceof HttpResponse) {
        const body = event.body;
        convertToDate(body);
      }
    })
  );
};
